/**
 * Keeps `--sh-hub-nav-height` in sync with a sticky hub nav's height, so
 * in-page anchors clear it via `scroll-margin-top`.
 *
 * @param {HTMLElement|null} el The sticky nav element.
 */
export function init_sticky_height(el) {
	if (!el) {
		return;
	}

	function set_height() {
		document.body.style.setProperty(`--sh-hub-nav-height`, `${el.offsetHeight}px`);
	}

	set_height();

	let resize_timer = null;

	window.addEventListener(`resize`, () => {
		window.clearTimeout(resize_timer);
		resize_timer = window.setTimeout(set_height, 250);
	});
}
